import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import MilestoneEventEntryContainer from '../../../components/componentsControlTower/MilestoneEventEntry/MilestoneEventEntryContainer';

class ctrlTwrMilestoneEventEntryView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <MilestoneEventEntryContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default ctrlTwrMilestoneEventEntryView;
